import React, { useState } from 'react'
import { TextField, InputAdornment, IconButton, TextFieldProps } from '@mui/material'
import { useField } from 'formik'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'

export type FormTextFieldProps = Omit<TextFieldProps, 'name'> & {
  name: string
  label: string
  type?: string
  disabled?: boolean
  placeholder?: string
}

const FormTextField: React.FC<FormTextFieldProps> = ({
  name,
  label,
  type = 'text',
  disabled = false,
  placeholder,
  slotProps,
  ...props
}) => {
  const [field, meta] = useField(name)
  const [showPassword, setShowPassword] = useState(false)

  const isPassword = type === 'password'
  const errorText = meta.touched && meta.error ? meta.error : ''

  return (
    <TextField
      disabled={disabled}
      {...field}
      {...props}
      type={isPassword ? (showPassword ? 'text' : 'password') : type}
      label={label}
      placeholder={placeholder}
      fullWidth
      variant="outlined"
      error={!!errorText}
      helperText={errorText}
      margin="dense"
      autoComplete="off"
      onWheel={(e) => {
        if (type === 'number') {
          ;(e.target as HTMLInputElement).blur()
        }
      }}
      slotProps={{
        ...slotProps,
        input: {
          ...(typeof slotProps?.input === 'object' ? slotProps.input : {}),

          endAdornment: isPassword ? (
            <InputAdornment position="end">
              <IconButton onClick={() => setShowPassword((prev) => !prev)} edge="end">
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ) : undefined
        }
      }}
    />
  )
}

export default FormTextField
